import React, { useState } from 'react';
import { Layout, Button } from 'antd';
import styled from 'styled-components';

import withAuth from '~/libs/withAuth';
import { BlockLayout, ContentLayout, MainBlockLayout } from '~/components/layouts';
import ExpensesList from '~/components/ExpensesList';
import UploadDrop from '~/components/UploadDrop';
import ExpenseModal from '~/components/ExpenseModal';

const UploadBlockLayout = styled(BlockLayout)`
	margin-top: -21px;
	margin-left: 50%;
	transform: translateX(-50%);
	margin-bottom: 20px;
	width: 90%;
`;

const Expenses = () => {
	const [ showUploads, setShowUploads ] = useState(false);
	const [ expense, setExpense ] = useState(null);

	// const onSaveNextClick = () => {
	// 	await onSaveClick();
	// }


	const jsxActions = <>
		<Button key='btn-expenses-uploads' type="primary" onClick={() => setShowUploads(!showUploads)}>
			{showUploads ? 'Close Uploads' : 'Open Uploads'}
		</Button>
	</>;

	return (
		<ContentLayout>
			<MainBlockLayout title='Expenses' actions={jsxActions}>
				
				{showUploads && <UploadBlockLayout style={{ marginTop: -21 }} 
					contentStyle={{ borderTop: 'none', padding: '0 10px 10px 10px' }}>
					<UploadDrop mode='expenses' />
				</UploadBlockLayout>}

				<BlockLayout size='8' contentStyle={{ padding: 0 }}>
					<ExpensesList onEditClick={(e) => { setExpense(e) }} />
				</BlockLayout>

      </MainBlockLayout>

			<ExpenseModal expense={expense} onClose={() => setExpense(null)} />
		</ContentLayout>
	);

};

export default withAuth(Expenses);